// This file is auto-generated. Do not edit.

import { LostTemplePath } from './lostTemplePath';

export const lostTemplePaths: readonly LostTemplePath[] = [
    {
        key: 0,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,B2", "B1,C1", "B2,C2", "C1,D1", "C2,D2", "D1,D2", "D1,E1", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "C1", "C2", "D1", "D2", "E1", "E2", "E3"]),
        percent: 0.03582890687,
    },
    {
        key: 1,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B4,B5", "B4,C4", "B5,C5", "C4,D4", "C5,D5", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A3", "A4", "A5", "B4", "B5", "C4", "C5", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.03582890687,
    },
    {
        key: 2,
        openDoors: new Set(["A2,A3", "A2,B2", "B1,B2", "B1,C1", "B2,C2", "C1,C2", "C1,D1", "D1,E1", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A2", "A3", "B1", "B2", "C1", "C2", "D1", "E1", "E2", "E3"]),
        percent: 0.0344036946,
    },
    {
        key: 3,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,B2", "B1,C1", "B2,C2", "C1,C2", "C2,D2", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "C1", "C2", "D2", "E2", "E3"]),
        percent: 0.03135029351,
    },
    {
        key: 4,
        openDoors: new Set(["A3,A4", "A4,B4", "B4,B5", "B4,C4", "B5,C5", "C4,D4", "C5,D5", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A3", "A4", "B4", "B5", "C4", "C5", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.02570509998,
    },
    {
        key: 5,
        openDoors: new Set(["A2,A3", "A2,B2", "B1,B2", "B1,C1", "B2,C2", "C1,D1", "C2,D2", "D1,D2", "D1,E1", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A2", "A3", "B1", "B2", "C1", "C2", "D1", "D2", "E1", "E2", "E3"]),
        percent: 0.02570509998,
    },
    {
        key: 6,
        openDoors: new Set(["A3,A4", "A4,B4", "B4,C4", "C4,C5", "C4,D4", "C5,D5", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A3", "A4", "B4", "C4", "C5", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.02868311457,
    },
    {
        key: 7,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,C2", "C1,C2", "C1,D1", "C2,D2", "D1,D2", "D1,E1", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A2", "A3", "B2", "C1", "C2", "D1", "D2", "E1", "E2", "E3"]),
        percent: 0.02868311457,
    },
    {
        key: 8,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B3,B4", "B3,C3", "C1,C2", "C1,D1", "C2,C3", "D1,E1", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "D1", "E1", "E2", "E3"]),
        percent: 0.02376612549,
    },
    {
        key: 9,
        openDoors: new Set(["A3,A4", "A4,B4", "B4,B5", "B4,C4", "B5,C5", "C4,C5", "C5,D5", "D2,D3", "D2,E2", "D3,D4", "D4,D5", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B4", "B5", "C4", "C5", "D2", "D3", "D4", "D5", "E2", "E3"]),
        percent: 0.0229357964,
    },
    {
        key: 10,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,C2", "C2,C3", "C2,D2", "C3,C4", "C4,C5", "C5,D5", "D2,D3", "D3,D4", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A2", "A3", "B2", "C2", "C3", "C4", "C5", "D2", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.02196050959,
    },
    {
        key: 11,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B3,B4", "B4,C4", "C1,C2", "C1,D1", "C2,C3", "C3,C4", "D1,E1", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D1", "E1", "E2", "E3"]),
        percent: 0.01932735533,
    },
    {
        key: 12,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B5,C5", "C2,C3", "C2,D2", "C3,C4", "C4,C5", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D2", "E2", "E3"]),
        percent: 0.02106347845,
    },
    {
        key: 13,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B5,C5", "C2,C3", "C3,C4", "C4,C5", "C5,D5", "D2,D3", "D2,E2", "D3,D4", "D4,D5", "E2,E3"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D2", "D3", "D4", "D5", "E2", "E3"]),
        percent: 0.01550613149,
    },
    {
        key: 14,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B3,B4", "B3,C3", "B4,B5", "B5,C5", "C3,C4", "C4,C5", "C5,D5", "D2,D3", "D2,E2", "D3,D4", "D4,D5", "E2,E3"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C3", "C4", "C5", "D2", "D3", "D4", "D5", "E2", "E3"]),
        percent: 0.01584408366,
    },
    {
        key: 15,
        openDoors: new Set(["A3,A4", "A4,B4", "B4,C4", "C1,C2", "C1,D1", "C2,C3", "C3,C4", "C4,D4", "D1,D2", "D1,E1", "D2,D3", "D3,D4", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B4", "C1", "C2", "C3", "C4", "D1", "D2", "D3", "D4", "E1", "E2", "E3"]),
        percent: 0.0192714676,
    },
    {
        key: 16,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B3,B4", "B3,C3", "B4,B5", "B5,C5", "C3,C4", "C3,D3", "C4,C5", "D2,D3", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B3", "B4", "B5", "C3", "C4", "C5", "D2", "D3", "E2", "E3"]),
        percent: 0.01455549341,
    },
    {
        key: 17,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B2,C2", "B3,C3", "C2,C3", "C3,D3", "D3,E3"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "C2", "C3", "D3", "E3"]),
        percent: 0.007878445574,
    },
    {
        key: 18,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B3,B4", "B3,C3", "B4,B5", "B5,C5", "C3,C4", "C3,D3", "C4,C5", "D3,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B3", "B4", "B5", "C3", "C4", "C5", "D3", "E3"]),
        percent: 0.01455549341,
    },
    {
        key: 19,
        openDoors: new Set(["A2,A3", "A2,B2", "B1,B2", "B1,C1", "B2,C2", "C1,C2", "C1,D1", "D1,D2", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A2", "A3", "B1", "B2", "C1", "C2", "D1", "D2", "E2", "E3"]),
        percent: 0.01003441093,
    },
    {
        key: 20,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B2,B3", "B2,C2", "B3,B4", "B3,C3", "B4,C4", "B5,C5", "C2,D2", "C3,C4", "C4,C5", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D2", "E2", "E3"]),
        percent: 0.01254655352,
    },
    {
        key: 21,
        openDoors: new Set(["A3,A4", "A4,B4", "B2,B3", "B2,C2", "B3,B4", "B3,C3", "C2,C3", "C2,D2", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B2", "B3", "B4", "C2", "C3", "D2", "E2", "E3"]),
        percent: 0.01254655352,
    },
    {
        key: 22,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,B2", "B1,C1", "B2,B3", "B3,C3", "C1,C2", "C2,C3", "C3,D3", "D3,E3"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "C1", "C2", "C3", "D3", "E3"]),
        percent: 0.01455549341,
    },
    {
        key: 23,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B3,C3", "C1,C2", "C1,D1", "C2,C3", "C3,D3", "D1,D2", "D1,E1", "D2,D3", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "C1", "C2", "C3", "D1", "D2", "D3", "E1", "E2", "E3"]),
        percent: 0.01165251529,
    },
    {
        key: 24,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B4,B5", "B4,C4", "B5,C5", "C3,C4", "C3,D3", "C4,C5", "D2,D3", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B4", "B5", "C3", "C4", "C5", "D2", "D3", "E2", "E3"]),
        percent: 0.01343584007,
    },
    {
        key: 25,
        openDoors: new Set(["A3,A4", "A4,B4", "B3,B4", "B3,C3", "C3,C4", "C3,D3", "C4,C5", "C5,D5", "D3,D4", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A3", "A4", "B3", "B4", "C3", "C4", "C5", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.01165251529,
    },
    {
        key: 26,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B2,C2", "B3,C3", "B4,C4", "C1,D1", "C2,C3", "C3,C4", "D1,E1", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D1", "E1", "E2", "E3"]),
        percent: 0.01181766836,
    },
    {
        key: 27,
        openDoors: new Set(["A3,A4", "A4,B4", "B4,B5", "B4,C4", "B5,C5", "C4,C5", "C5,D5", "D3,D4", "D3,E3", "D4,D5"]),
        openRooms: new Set(["A3", "A4", "B4", "B5", "C4", "C5", "D3", "D4", "D5", "E3"]),
        percent: 0.01290138548,
    },
    {
        key: 28,
        openDoors: new Set(["A3,A4", "A4,B4", "B2,B3", "B2,C2", "B3,B4", "B4,C4", "C2,C3", "C2,D2", "C3,C4", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B2", "B3", "B4", "C2", "C3", "C4", "D2", "E2", "E3"]),
        percent: 0.0112021648,
    },
    {
        key: 29,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B2,B3", "B2,C2", "B3,B4", "B3,C3", "B4,C4", "B5,C5", "C2,D2", "C3,D3", "C4,C5", "C5,D5", "D2,E2", "D3,D4", "D4,D5", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D2", "D3", "D4", "D5", "E2", "E3"]),
        percent: 0.004791049171,
    },
    {
        key: 30,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B4,B5", "B4,C4", "B5,C5", "C3,C4", "C3,D3", "C4,C5", "D3,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B4", "B5", "C3", "C4", "C5", "D3", "E3"]),
        percent: 0.01343584007,
    },
    {
        key: 31,
        openDoors: new Set(["A3,A4", "A4,B4", "B3,B4", "B3,C3", "B4,C4", "C3,C4", "C3,D3", "D2,D3", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B3", "B4", "C3", "C4", "D2", "D3", "E2", "E3"]),
        percent: 0.007878445574,
    },
    {
        key: 32,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B3,B4", "B3,C3", "B4,B5", "B5,C5", "C3,D3", "C5,D5", "D3,D4", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C3", "C5", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.01254886262,
    },
    {
        key: 33,
        openDoors: new Set(["A3,A4", "A4,B4", "B3,B4", "B3,C3", "C1,C2", "C1,D1", "C2,C3", "C3,D3", "D1,D2", "D1,E1", "D2,D3", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B3", "B4", "C1", "C2", "C3", "D1", "D2", "D3", "E1", "E2", "E3"]),
        percent: 0.01165251529,
    },
    {
        key: 34,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B1,B2", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,C4", "B5,C5", "C1,D1", "C2,C3", "C3,C4", "C4,C5", "D1,E1", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "E1", "E2", "E3"]),
        percent: 0.009601855543,
    },
    {
        key: 35,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B3,C3", "C3,C4", "C3,D3", "C4,C5", "C5,D5", "D3,D4", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "C3", "C4", "C5", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.01165251529,
    },
    {
        key: 36,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,B2", "B1,C1", "B2,B3", "B3,B4", "B4,C4", "C1,C2", "C2,C3", "C3,C4", "C4,D4", "D2,D3", "D2,E2", "D3,D4", "E2,E3"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D2", "D3", "D4", "E2", "E3"]),
        percent: 0.01371575341,
    },
    {
        key: 37,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B5,C5", "C2,C3", "C3,C4", "C4,C5", "C5,D5", "D3,D4", "D3,E3", "D4,D5"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D3", "D4", "D5", "E3"]),
        percent: 0.008722198962,
    },
    {
        key: 38,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,B2", "B1,C1", "B2,B3", "B3,C3", "C1,C2", "C2,C3", "C3,D3", "D2,D3", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "C1", "C2", "C3", "D2", "D3", "E2", "E3"]),
        percent: 0.01455549341,
    },
    {
        key: 39,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B3,B4", "B3,C3", "B4,B5", "B5,C5", "C3,C4", "C4,C5", "C5,D5", "D3,D4", "D3,E3", "D4,D5"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C3", "C4", "C5", "D3", "D4", "D5", "E3"]),
        percent: 0.008912297061,
    },
    {
        key: 40,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B3,B4", "B3,C3", "C1,D1", "C3,D3", "D1,D2", "D1,E1", "D2,D3", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "C1", "C3", "D1", "D2", "D3", "E1", "E2", "E3"]),
        percent: 0.01254886262,
    },
    {
        key: 41,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B3,B4", "B3,C3", "C1,D1", "C2,C3", "C2,D2", "D1,D2", "D1,E1", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "D1", "D2", "E1", "E2", "E3"]),
        percent: 0.005378083982,
    },
    {
        key: 42,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B3,C3", "B4,C4", "C1,C2", "C2,C3", "C4,D4", "D2,D3", "D2,E2", "D3,D4", "E2,E3"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D2", "D3", "D4", "E2", "E3"]),
        percent: 0.007169459157,
    },
    {
        key: 43,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,B2", "B1,C1", "B2,B3", "B3,B4", "B4,C4", "C1,C2", "C2,C3", "C3,C4", "C4,D4", "D3,D4", "D3,E3"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D3", "D4", "E3"]),
        percent: 0.01028681506,
    },
    {
        key: 44,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B2,C2", "B3,C3", "C2,C3", "C3,D3", "D2,D3", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "C2", "C3", "D2", "D3", "E2", "E3"]),
        percent: 0.007878445574,
    },
    {
        key: 45,
        openDoors: new Set(["A3,A4", "A4,B4", "B3,B4", "B3,C3", "B4,C4", "C3,C4", "C3,D3", "D3,E3"]),
        openRooms: new Set(["A3", "A4", "B3", "B4", "C3", "C4", "D3", "E3"]),
        percent: 0.007878445574,
    },
    {
        key: 46,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B3,C3", "B4,C4", "C1,C2", "C1,D1", "C3,D3", "C4,D4", "D1,D2", "D2,D3", "D4,E4", "E3,E4"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D1", "D2", "D3", "D4", "E3", "E4"]),
        percent: 0.004791049171,
    },
    {
        key: 47,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,C2", "B3,B4", "B3,C3", "B4,B5", "B4,C4", "B5,C5", "C2,C3", "C3,C4", "C5,D5", "D2,D3", "D2,E2", "D3,D4", "D4,D5", "E2,E3"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D2", "D3", "D4", "D5", "E2", "E3"]),
        percent: 0.007878445574,
    },
    {
        key: 48,
        openDoors: new Set(["A2,A3", "A2,B2", "B1,B2", "B1,C1", "B3,B4", "B3,C3", "B4,B5", "B4,C4", "B5,C5", "C1,C2", "C1,D1", "C2,C3", "C4,D4", "C5,D5", "D1,D2", "D2,D3", "D3,D4", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A2", "A3", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.003213524631,
    },
    {
        key: 49,
        openDoors: new Set(["A3,A4", "A4,B4", "B3,B4", "B3,C3", "B4,C4", "C3,D3", "C4,C5", "C5,D5", "D3,D4", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A3", "A4", "B3", "B4", "C3", "C4", "C5", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.005931946149,
    },
    {
        key: 50,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B4,B5", "B4,C4", "B5,C5", "C2,C3", "C2,D2", "C3,C4", "C3,D3", "C5,D5", "D2,E2", "D3,D4", "D4,D5", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B4", "B5", "C2", "C3", "C4", "C5", "D2", "D3", "D4", "D5", "E2", "E3"]),
        percent: 0.006717920037,
    },
    {
        key: 51,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,B2", "B1,C1", "B2,B3", "B3,C3", "C1,C2", "C2,D2", "C3,C4", "C4,C5", "C4,D4", "C5,D5", "D2,D3", "D3,D4", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "C1", "C2", "C3", "C4", "C5", "D2", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.001259610007,
    },
    {
        key: 52,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B2,C2", "B3,B4", "B4,C4", "C2,C3", "C3,C4", "C4,D4", "D2,D3", "D2,E2", "D3,D4", "E2,E3"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "C2", "C3", "C4", "D2", "D3", "D4", "E2", "E3"]),
        percent: 0.006401237029,
    },
    {
        key: 53,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B1,B2", "B1,C1", "B2,B3", "B3,B4", "B4,C4", "B5,C5", "C1,D1", "C2,C3", "C2,D2", "C3,C4", "C4,C5", "D1,D2", "D1,E1", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "E1", "E2", "E3"]),
        percent: 0.004033562987,
    },
    {
        key: 54,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B3,B4", "B4,C4", "C1,C2", "C1,D1", "C2,C3", "C3,C4", "D1,D2", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D1", "D2", "E2", "E3"]),
        percent: 0.005637145305,
    },
    {
        key: 55,
        openDoors: new Set(["A3,A4", "A4,B4", "B4,B5", "B4,C4", "B5,C5", "C4,C5", "C5,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A3", "A4", "B4", "B5", "C4", "C5", "D5", "E3", "E4", "E5"]),
        percent: 0.005733949101,
    },
    {
        key: 56,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B3,C3", "B4,C4", "C1,C2", "C2,C3", "C4,D4", "D3,D4", "D3,E3"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D3", "D4", "E3"]),
        percent: 0.005377094368,
    },
    {
        key: 57,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B3,B4", "B3,C3", "C1,C2", "C1,D1", "C2,C3", "D1,D2", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "D1", "D2", "E2", "E3"]),
        percent: 0.006931786603,
    },
    {
        key: 58,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,C2", "B3,B4", "B3,C3", "B4,B5", "B5,C5", "C2,C3", "C3,C4", "C4,D4", "C5,D5", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.005378083982,
    },
    {
        key: 59,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,B2", "B1,C1", "B2,C2", "C1,D1", "C2,C3", "C3,C4", "C3,D3", "C4,D4", "D1,D2", "D2,D3", "D4,E4", "E3,E4"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "C1", "C2", "C3", "C4", "D1", "D2", "D3", "D4", "E3", "E4"]),
        percent: 0.006717920037,
    },
    {
        key: 60,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B3,B4", "B3,C3", "B4,B5", "B5,C5", "C3,C4", "C4,D4", "C5,D5", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C3", "C4", "C5", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.005378083982,
    },
    {
        key: 61,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B3,B4", "B3,C3", "B4,C4", "C3,C4", "C4,D4", "D2,D3", "D2,E2", "D3,D4", "E2,E3"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "C3", "C4", "D2", "D3", "D4", "E2", "E3"]),
        percent: 0.007169459157,
    },
    {
        key: 62,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B3,B4", "B3,C3", "B4,C4", "C3,C4", "C4,D4", "D3,D4", "D3,E3"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "C3", "C4", "D3", "D4", "E3"]),
        percent: 0.005377094368,
    },
    {
        key: 63,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B4,B5", "B4,C4", "B5,C5", "C1,C2", "C1,D1", "C2,C3", "C2,D2", "C3,C4", "C5,D5", "D1,E1", "D2,D3", "D3,D4", "D4,D5", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "D3", "D4", "D5", "E1", "E2", "E3"]),
        percent: 0.006717920037,
    },
    {
        key: 64,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B3,B4", "B3,C3", "B4,C4", "C1,C2", "C1,D1", "C2,C3", "C4,D4", "D1,D2", "D1,E1", "D2,D3", "D3,D4", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D1", "D2", "D3", "D4", "E1", "E2", "E3"]),
        percent: 0.004033562987,
    },
    {
        key: 65,
        openDoors: new Set(["A3,A4", "A4,B4", "B2,B3", "B2,C2", "B3,B4", "B3,C3", "C1,C2", "C1,D1", "C3,D3", "D1,D2", "D1,E1", "D2,D3", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B2", "B3", "B4", "C1", "C2", "C3", "D1", "D2", "D3", "E1", "E2", "E3"]),
        percent: 0.005378083982,
    },
    {
        key: 66,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B3,C3", "B4,C4", "C1,D1", "C2,C3", "C2,D2", "C3,C4", "D1,D2", "D1,E1", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D1", "D2", "E1", "E2", "E3"]),
        percent: 0.005378083982,
    },
    {
        key: 67,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B4,C4", "B5,C5", "C1,C2", "C2,C3", "C3,C4", "C5,D5", "D2,D3", "D2,E2", "D3,D4", "D4,D5", "E2,E3"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D2", "D3", "D4", "D5", "E2", "E3"]),
        percent: 0.006401237029,
    },
    {
        key: 68,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,B2", "B1,C1", "B2,B3", "B3,B4", "B4,C4", "C1,C2", "C2,C3", "C3,C4", "C4,D4", "D4,E4", "E3,E4"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D4", "E3", "E4"]),
        percent: 0.003428938352,
    },
    {
        key: 69,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B3,B4", "B3,C3", "B4,B5", "B5,C5", "C3,C4", "C4,C5", "C5,D5", "D4,D5", "D4,E4", "E3,E4"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C3", "C4", "C5", "D4", "D5", "E3", "E4"]),
        percent: 0.002970765687,
    },
    {
        key: 70,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B3,B4", "B3,C3", "B4,B5", "B5,C5", "C1,C2", "C1,D1", "C2,C3", "C2,D2", "C4,C5", "C4,D4", "D1,E1", "D2,D3", "D3,D4", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "D3", "D4", "E1", "E2", "E3"]),
        percent: 0.001259610007,
    },
    {
        key: 71,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B1,B2", "B1,C1", "B2,B3", "B2,C2", "B3,C3", "B5,C5", "C1,D1", "C2,D2", "C3,C4", "C4,C5", "C5,D5", "D1,E1", "D2,D3", "D3,D4", "D4,D5", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B1", "B2", "B3", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "D3", "D4", "D5", "E1", "E2", "E3"]),
        percent: 0.0009955625328,
    },
    {
        key: 72,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,B2", "B1,C1", "B2,C2", "C1,C2", "C2,C3", "C3,D3", "D3,E3"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "C1", "C2", "C3", "D3", "E3"]),
        percent: 0.004478613358,
    },
    {
        key: 73,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B4,B5", "B4,C4", "B5,C5", "C4,C5", "C4,D4", "D2,D3", "D2,E2", "D3,D4", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B4", "B5", "C4", "C5", "D2", "D3", "D4", "E2", "E3"]),
        percent: 0.004478613358,
    },
    {
        key: 74,
        openDoors: new Set(["A3,A4", "A4,B4", "B4,B5", "B4,C4", "B5,C5", "C4,C5", "C5,D5", "D4,D5", "D4,E4", "E3,E4"]),
        openRooms: new Set(["A3", "A4", "B4", "B5", "C4", "C5", "D4", "D5", "E3", "E4"]),
        percent: 0.004300461826,
    },
    {
        key: 75,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B3,B4", "B3,C3", "B4,B5", "B4,C4", "B5,C5", "C1,C2", "C1,D1", "C2,C3", "C4,D4", "C5,D5", "D1,D2", "D2,D3", "D3,D4", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.001071174877,
    },
    {
        key: 76,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B2,C2", "B3,C3", "C1,C2", "C1,D1", "C3,D3", "D1,D2", "D1,E1", "D2,D3", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "C1", "C2", "C3", "D1", "D2", "D3", "E1", "E2", "E3"]),
        percent: 0.005931946149,
    },
    {
        key: 77,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B5,C5", "C2,C3", "C3,C4", "C4,C5", "C5,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D5", "E3", "E4", "E5"]),
        percent: 0.003876532872,
    },
    {
        key: 78,
        openDoors: new Set(["A3,A4", "A4,B4", "B3,B4", "B3,C3", "B4,C4", "C1,C2", "C1,D1", "C2,C3", "C2,D2", "C4,D4", "D1,E1", "D2,D3", "D3,D4", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B3", "B4", "C1", "C2", "C3", "C4", "D1", "D2", "D3", "D4", "E1", "E2", "E3"]),
        percent: 0.00295441709,
    },
    {
        key: 79,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,B2", "B1,C1", "B2,C2", "C1,D1", "C2,C3", "C3,C4", "C4,C5", "C4,D4", "C5,D5", "D1,D2", "D2,D3", "D3,D4", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.006717920037,
    },
    {
        key: 80,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,B2", "B1,C1", "B2,C2", "C1,C2", "C2,D2", "D2,D3", "D3,E3"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "C1", "C2", "D2", "D3", "E3"]),
        percent: 0.004478613358,
    },
    {
        key: 81,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B5,C5", "C2,C3", "C2,D2", "C3,C4", "C4,C5", "D2,D3", "D3,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D2", "D3", "E3"]),
        percent: 0.00300906835,
    },
    {
        key: 82,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B4,B5", "B4,C4", "B5,C5", "C4,C5", "C4,D4", "D3,D4", "D3,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B4", "B5", "C4", "C5", "D3", "D4", "E3"]),
        percent: 0.003358960019,
    },
    {
        key: 83,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B2,C2", "B3,B4", "B4,C4", "C2,C3", "C3,C4", "C4,D4", "D3,D4", "D3,E3"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "C2", "C3", "C4", "D3", "D4", "E3"]),
        percent: 0.004800927772,
    },
    {
        key: 84,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B2,C2", "B3,C3", "B4,C4", "C1,D1", "C2,C3", "C3,C4", "D1,D2", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D1", "D2", "E2", "E3"]),
        percent: 0.003446819939,
    },
    {
        key: 85,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B2,C2", "B3,C3", "C2,D2", "C3,C4", "C4,C5", "C4,D4", "C5,D5", "D2,D3", "D3,D4", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "C2", "C3", "C4", "C5", "D2", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.00295441709,
    },
    {
        key: 86,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B4,C4", "B5,C5", "C1,C2", "C2,C3", "C3,C4", "C5,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D5", "E3", "E4", "E5"]),
        percent: 0.001600309257,
    },
    {
        key: 87,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B3,B4", "B3,C3", "B4,B5", "B5,C5", "C3,C4", "C4,C5", "C5,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C3", "C4", "C5", "D5", "E3", "E4", "E5"]),
        percent: 0.003961020916,
    },
    {
        key: 88,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B5,C5", "C1,C2", "C2,C3", "C3,C4", "C4,D4", "C5,D5", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.001344520996,
    },
    {
        key: 89,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B4,C4", "B5,C5", "C1,C2", "C1,D1", "C4,D4", "C5,D5", "D1,D2", "D2,D3", "D3,D4", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C4", "C5", "D1", "D2", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.001428233169,
    },
    {
        key: 90,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,C4", "C1,C2", "C2,C3", "C3,D3", "C4,C5", "C5,D5", "D3,D4", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "C5", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.001344520996,
    },
    {
        key: 91,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,C2", "B3,B4", "B3,C3", "B4,B5", "B4,C4", "B5,C5", "C2,C3", "C3,C4", "C5,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D5", "E3", "E4", "E5"]),
        percent: 0.001969611394,
    },
    {
        key: 92,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B4,C4", "B5,C5", "C1,C2", "C2,C3", "C3,C4", "C5,D5", "D3,D4", "D3,E3", "D4,D5"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D3", "D4", "D5", "E3"]),
        percent: 0.003600695829,
    },
    {
        key: 93,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,C2", "B3,B4", "B3,C3", "B4,B5", "B4,C4", "B5,C5", "C2,C3", "C3,C4", "C5,D5", "D3,D4", "D3,E3", "D4,D5"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D3", "D4", "D5", "E3"]),
        percent: 0.004431625635,
    },
    {
        key: 94,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B2,B3", "B2,C2", "B3,B4", "B4,C4", "B5,C5", "C1,C2", "C1,D1", "C3,C4", "C3,D3", "C4,C5", "D1,D2", "D1,E1", "D2,D3", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "D3", "E1", "E2", "E3"]),
        percent: 0.004033562987,
    },
    {
        key: 95,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B1,B2", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,C4", "B5,C5", "C1,D1", "C2,C3", "C3,D3", "C4,C5", "C5,D5", "D1,E1", "D3,D4", "D4,D5", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D3", "D4", "D5", "E1", "E2", "E3"]),
        percent: 0.0009955625328,
    },
    {
        key: 96,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,C2", "B3,B4", "B3,C3", "B4,B5", "B4,C4", "B5,C5", "C2,C3", "C2,D2", "C4,D4", "C5,D5", "D2,D3", "D3,D4", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D2", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.00295441709,
    },
    {
        key: 97,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B3,B4", "B3,C3", "B4,C4", "C3,D3", "C4,C5", "C5,D5", "D3,D4", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "C3", "C4", "C5", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.005378083982,
    },
    {
        key: 98,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B1,B2", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,C4", "B5,C5", "C1,D1", "C2,C3", "C3,C4", "C4,C5", "D1,D2", "D2,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "E2", "E3"]),
        percent: 0.0028005412,
    },
    {
        key: 99,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B4,C4", "B5,C5", "C1,C2", "C1,D1", "C3,C4", "C3,D3", "C5,D5", "D1,D2", "D2,D3", "D4,D5", "D4,E4", "E3,E4"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "D3", "D4", "D5", "E3", "E4"]),
        percent: 0.003213524631,
    },
    {
        key: 100,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B3,B4", "B3,C3", "B4,C4", "C3,C4", "C4,D4", "D4,E4", "E3,E4"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "C3", "C4", "D4", "E3", "E4"]),
        percent: 0.001792364789,
    },
    {
        key: 101,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B2,B3", "B2,C2", "B3,B4", "B3,C3", "B4,C4", "B5,C5", "C2,D2", "C3,C4", "C4,C5", "D2,D3", "D3,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D2", "D3", "E3"]),
        percent: 0.001792364789,
    },
    {
        key: 102,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B4,C4", "B5,C5", "C1,C2", "C2,C3", "C3,C4", "C5,D5", "D4,D5", "D4,E4", "E3,E4"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D4", "D5", "E3", "E4"]),
        percent: 0.001200231943,
    },
    {
        key: 103,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B5,C5", "C2,C3", "C3,C4", "C4,C5", "C5,D5", "D4,D5", "D4,E4", "E3,E4"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D4", "D5", "E3", "E4"]),
        percent: 0.002907399654,
    },
    {
        key: 104,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B2,C2", "B3,C3", "B4,C4", "C1,D1", "C2,D2", "C3,C4", "C4,D4", "D1,E1", "D2,D3", "D3,D4", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D1", "D2", "D3", "D4", "E1", "E2", "E3"]),
        percent: 0.00295441709,
    },
    {
        key: 105,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B3,B4", "B3,C3", "C1,C2", "C1,D1", "C2,C3", "D1,D2", "D2,D3", "D3,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "D1", "D2", "D3", "E3"]),
        percent: 0.000990255229,
    },
    {
        key: 106,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B2,C2", "B3,C3", "B4,B5", "B5,C5", "C1,D1", "C2,D2", "C3,C4", "C4,C5", "C5,D5", "D1,E1", "D2,D3", "D3,D4", "D4,D5", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "D3", "D4", "D5", "E1", "E2", "E3"]),
        percent: 0.0003318541776,
    },
    {
        key: 107,
        openDoors: new Set(["A3,A4", "A4,B4", "B2,B3", "B2,C2", "B3,B4", "B3,C3", "C2,D2", "C3,C4", "C4,C5", "C5,D5", "D2,D3", "D3,D4", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A3", "A4", "B2", "B3", "B4", "C2", "C3", "C4", "C5", "D2", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.001344520996,
    },
    {
        key: 108,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B1,B2", "B1,C1", "B2,B3", "B3,B4", "B4,C4", "B5,C5", "C1,D1", "C3,C4", "C3,D3", "C4,C5", "D1,D2", "D1,E1", "D2,D3", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B1", "B2", "B3", "B4", "B5", "C1", "C3", "C4", "C5", "D1", "D2", "D3", "E1", "E2", "E3"]),
        percent: 0.001344520996,
    },
    {
        key: 109,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B1,B2", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,C4", "B5,C5", "C1,D1", "C2,C3", "C3,D3", "C4,C5", "C5,D5", "D1,D2", "D2,E2", "D3,D4", "D4,D5", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "D3", "D4", "D5", "E2", "E3"]),
        percent: 0.0003318541776,
    },
    {
        key: 110,
        openDoors: new Set(["A3,A4", "A4,B4", "B2,B3", "B2,C2", "B3,B4", "B3,C3", "C2,C3", "C2,D2", "D2,D3", "D3,E3"]),
        openRooms: new Set(["A3", "A4", "B2", "B3", "B4", "C2", "C3", "D2", "D3", "E3"]),
        percent: 0.001792364789,
    },
    {
        key: 111,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B3,C3", "B4,C4", "C1,C2", "C2,C3", "C4,D4", "D4,E4", "E3,E4"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D4", "E3", "E4"]),
        percent: 0.001792364789,
    },
    {
        key: 112,
        openDoors: new Set(["A2,A3", "A2,B2", "B1,B2", "B1,C1", "B2,C2", "C1,C2", "C1,D1", "D1,D2", "D2,D3", "D3,E3"]),
        openRooms: new Set(["A2", "A3", "B1", "B2", "C1", "C2", "D1", "D2", "D3", "E3"]),
        percent: 0.001433487275,
    },
    {
        key: 113,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,B3", "B2,C2", "B3,B4", "B4,C4", "C2,C3", "C3,C4", "C4,D4", "D4,E4", "E3,E4"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "C2", "C3", "C4", "D4", "E3", "E4"]),
        percent: 0.001600309257,
    },
    {
        key: 114,
        openDoors: new Set(["A2,A3", "A2,B2", "B2,C2", "B3,B4", "B3,C3", "B4,B5", "B4,C4", "B5,C5", "C2,C3", "C3,C4", "C5,D5", "D4,D5", "D4,E4", "E3,E4"]),
        openRooms: new Set(["A2", "A3", "B2", "B3", "B4", "B5", "C2", "C3", "C4", "C5", "D4", "D5", "E3", "E4"]),
        percent: 0.001477208545,
    },
    {
        key: 115,
        openDoors: new Set(["A3,A4", "A4,B4", "B2,B3", "B2,C2", "B3,B4", "B4,C4", "C2,C3", "C2,D2", "C3,C4", "D2,D3", "D3,E3"]),
        openRooms: new Set(["A3", "A4", "B2", "B3", "B4", "C2", "C3", "C4", "D2", "D3", "E3"]),
        percent: 0.001600309257,
    },
    {
        key: 116,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B4,B5", "B4,C4", "B5,C5", "C4,C5", "C4,D4", "D4,E4", "E3,E4"]),
        openRooms: new Set(["A3", "A4", "A5", "B4", "B5", "C4", "C5", "D4", "E3", "E4"]),
        percent: 0.00111965334,
    },
    {
        key: 117,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B3,B4", "B4,C4", "C1,C2", "C1,D1", "C2,C3", "C3,C4", "D1,D2", "D2,D3", "D3,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D1", "D2", "D3", "E3"]),
        percent: 0.0008053064721,
    },
    {
        key: 118,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B4,C4", "B5,C5", "C1,C2", "C1,D1", "C3,C4", "C3,D3", "C5,D5", "D1,D2", "D2,D3", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "D3", "D5", "E3", "E4", "E5"]),
        percent: 0.001071174877,
    },
    {
        key: 119,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B3,B4", "B3,C3", "B4,B5", "B5,C5", "C1,C2", "C1,D1", "C2,C3", "C2,D2", "C5,D5", "D1,E1", "D2,D3", "D3,D4", "D4,D5", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B3", "B4", "B5", "C1", "C2", "C3", "C5", "D1", "D2", "D3", "D4", "D5", "E1", "E2", "E3"]),
        percent: 0.003778830021,
    },
    {
        key: 120,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,B5", "B5,C5", "C1,C2", "C2,C3", "C3,D3", "C5,D5", "D3,D4", "D4,D5", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C5", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.004033562987,
    },
    {
        key: 121,
        openDoors: new Set(["A3,A4", "A4,B4", "B1,B2", "B1,C1", "B2,B3", "B2,C2", "B3,C3", "B4,C4", "C1,D1", "C2,C3", "C3,C4", "D1,D2", "D2,D3", "D3,E3"]),
        openRooms: new Set(["A3", "A4", "B1", "B2", "B3", "B4", "C1", "C2", "C3", "C4", "D1", "D2", "D3", "E3"]),
        percent: 0.0004924028484,
    },
    {
        key: 122,
        openDoors: new Set(["A1,A2", "A1,B1", "A2,A3", "B1,B2", "B1,C1", "B2,B3", "B3,C3", "C1,D1", "C3,C4", "C4,C5", "C4,D4", "C5,D5", "D1,D2", "D2,D3", "D3,D4", "D5,E5", "E3,E4", "E4,E5"]),
        openRooms: new Set(["A1", "A2", "A3", "B1", "B2", "B3", "C1", "C3", "C4", "C5", "D1", "D2", "D3", "D4", "D5", "E3", "E4", "E5"]),
        percent: 0.0004198700023,
    },
    {
        key: 123,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B1,B2", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,C4", "B5,C5", "C1,D1", "C2,D2", "C4,C5", "C5,D5", "D1,E1", "D2,D3", "D3,D4", "D4,D5", "E1,E2", "E2,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C4", "C5", "D1", "D2", "D3", "D4", "D5", "E1", "E2", "E3"]),
        percent: 0.003982250131,
    },
    {
        key: 124,
        openDoors: new Set(["A3,A4", "A4,A5", "A5,B5", "B1,B2", "B1,C1", "B2,B3", "B2,C2", "B3,B4", "B4,C4", "B5,C5", "C1,D1", "C2,C3", "C3,C4", "C4,C5", "D1,D2", "D2,D3", "D3,E3"]),
        openRooms: new Set(["A3", "A4", "A5", "B1", "B2", "B3", "B4", "B5", "C1", "C2", "C3", "C4", "C5", "D1", "D2", "D3", "E3"]),
        percent: 0.0004000773143,
    }
];
